import TwoColumnLayOut from "../../../../layouts/two-columns/two-column-layout";
import NominationProcessComponent from "./components/index.component";

const NominationProcess = () => {
  const breadcrumbPath = "Who-We-Are%2FGovernance%2FNomination-Process"; // %2FWho-We-Are%2FGovernance%2FNomination-Process page content

  return (
    <>
      <TwoColumnLayOut breadcrumbPath={breadcrumbPath} isBreadcrumbpath={true} showAds={true}>
        <NominationProcessComponent />
      </TwoColumnLayOut>
    </>
  );
};

export default NominationProcess;
